import React from 'react';
import {
	Stage,
	Layer,
	Text,
	Image as KonvaImage,
	Rect,
	Transformer,
} from 'react-konva';
import Konva from 'konva';
import * as R from 'ramda';

export type P_Canvas = {
	text: string;
	fontFamily: string;
	fontSize: number;
	fontColor: string;
	fontStrokeColor: string;
	lineHeight: number;
	bgImage?: HTMLImageElement;
	bgNoise?: HTMLImageElement;
	bgOpacity: number;
	bgColor: string;
	ref_stage: React.RefObject<Konva.Stage>;
	//ref_image: React.RefObject<Konva.Image>;
	stageWidth: number;
	mode: t_bgImageMode;
};

export type t_bgImageMode = 'REPEAT' | 'FIT' | 'TRANSFORM' | 'CONSTANT';
type t_size = { width: number; height: number };
type t_position = { x: number; y: number };
type t_sizePosition = t_size & t_position;
export default function Canvas(props: P_Canvas) {
	const origBgImageWidth = props.bgImage ? props.bgImage.width : 0;
	const origBgImageHeight = props.bgImage ? props.bgImage.height : 0;

	const defaultBgImageSizePosition = {
		x: 0,
		y: 0,
		width: origBgImageWidth,
		height: origBgImageHeight,
	};
	const [state_stageH, set_stageH] = React.useState<number>(0);
	const ref_text = React.useRef<Konva.Text>(null); //ステージの高さ決定に使う
	// set crossOrigin of image as second argument
	//const [state_image, set_imageStatus] = useImage(props.imageUrl, 'anonymous');
	const [state_bgImageSizePosition, set_bgImageSizePosition] =
		React.useState<t_sizePosition>(defaultBgImageSizePosition);

	//画像またはモードが変わった時
	React.useEffect(() => {
		//CONSTANT,TRANSFROM以外は一旦一とサイズをリセット
		props.mode !== 'CONSTANT' &&
			props.mode !== 'TRANSFORM' &&
			set_bgImageSizePosition(defaultBgImageSizePosition);
	}, [origBgImageWidth, origBgImageHeight, props.mode]);

	//ステージの大きさが変わる可能性があるとき、または画像が変わったとき
	React.useEffect(() => {
		const stageH = R.defaultTo(0, ref_text.current?.height());
		set_stageH(stageH);

		set_bgImageSizePosition((e) => {
			//FITは縦か横がステージと同じサイズになる比率で拡大
			const imageSize =
				props.mode === 'FIT'
					? calcFitImageSizeToStage(
							stageH,
							props.stageWidth,
							origBgImageHeight,
							origBgImageWidth,
					  )
					: {
							width: e.width,
							height: e.height,
					  };
			//FITは位置を中心に
			const imagePosition =
				props.mode === 'FIT'
					? marginForCenter(
							{ width: props.stageWidth, height: stageH },
							{ width: imageSize.width, height: imageSize.height },
					  )
					: { x: e.x, y: e.y };
			/*
			console.log({
				positionsizeeee: {
					mode: props.mode,
					stageH: stageH,
					origs: {
						stageW: props.stageWidth,
						imageH: origBgImageHeight,
						imageW: origBgImageWidth,
					},
					prevStates: e,
					new: {
						...imagePosition,
						...imageSize,
					},
				},
			});
			*/
			return {
				...imagePosition,
				...imageSize,
			};
		});
	}, [
		props.stageWidth,
		origBgImageWidth,
		origBgImageHeight,
		props.text,
		props.mode,
		props.fontSize,
		props.lineHeight,
		props.fontFamily,
	]);
	/*
	console.log({
		text: props.text,
		textwidth: ref_text.current?.width(),
		textHeight: ref_text.current?.height(),
		textmeasure: ref_text.current?.measureSize(props.text),
		//imageref: ref_image.current?.size(),
		imageorigsize: { H: origBgImageHeight, W: origBgImageWidth },
		imageCurrentSizePosition: { ...state_bgImageSizePosition },
		stageSize: { H: state_stageH, W: props.stageWidth },
		baseURI: props.bgImage?.baseURI,
		props: props,
	});
	*/

	//set_stageW(R.defaultTo(10, ref_text.current?.width()));
	//set_stageH(R.defaultTo(10, ref_text.current?.height()));
	return (
		<Stage
			ref={props.ref_stage}
			width={props.stageWidth}
			height={state_stageH}
			preventDefault={true}
		>
			<Layer preventDefault={true}>
				{/* 背景色 */}
				<Rect
					x={0}
					y={0}
					width={props.stageWidth}
					height={state_stageH}
					fill={props.bgColor}
					preventDefault={true}
				/>

				{props.mode === 'REPEAT' && props.bgImage && (
					<Rect
						fillPatternImage={props.bgImage}
						width={props.stageWidth}
						height={state_stageH}
						x={0}
						y={0}
						opacity={props.bgOpacity}
						preventDefault={true}
					/>
				)}
				{(props.mode === 'FIT' || props.mode === 'CONSTANT') && props.bgImage && (
					<KonvaImage
						//opacity={0.5}
						image={props.bgImage}
						width={state_bgImageSizePosition.width}
						height={state_bgImageSizePosition.height}
						x={state_bgImageSizePosition.x}
						y={state_bgImageSizePosition.y}
						opacity={props.bgOpacity}
						preventDefault={true}
					/>
				)}
				{props.bgNoise && (
					<Rect
						fillPatternImage={props.bgNoise}
						width={props.stageWidth}
						height={state_stageH}
						x={0}
						y={0}
						opacity={props.bgOpacity}
						preventDefault={true}
					/>
				)}
				<Text
					ref={ref_text}
					text={props.text}
					width={props.stageWidth} //=maxwidthでありminwidth
					fill={props.fontColor}
					fontSize={props.fontSize}
					fontFamily={props.fontFamily}
					fontStyle={'bold'}
					stroke={props.fontStrokeColor}
					strokeWidth={6}
					fillAfterStrokeEnabled={true}
					lineHeight={props.lineHeight}
					padding={8}
					preventDefault={true}
				/>
				{props.mode === 'TRANSFORM' && props.bgImage && (
					<TransformableRect
						image={props.bgImage}
						rectProps={state_bgImageSizePosition}
						isSelected={true}
						onChange={(newAttrs) => set_bgImageSizePosition(newAttrs)}
					/>
				)}
			</Layer>
		</Stage>
	);
}

const TransformableRect = (props: {
	image: HTMLImageElement | undefined;
	rectProps: t_sizePosition;
	isSelected: boolean;
	onChange: (p: t_sizePosition) => any;
}) => {
	const { rectProps, isSelected, onChange } = props;
	const rectRef = React.useRef<Konva.Rect>();
	const trRef = React.useRef<Konva.Transformer>();

	React.useEffect(() => {
		if (isSelected && trRef.current && rectRef.current) {
			// we need to attach transformer manually
			trRef.current.nodes([rectRef.current]);
			const l = trRef.current.getLayer();
			l && l.batchDraw();
		}
	}, [isSelected]);

	return (
		<React.Fragment>
			<KonvaImage
				/* @ts-ignore */
				ref={rectRef}
				{...rectProps}
				image={props.image}
				opacity={0.5}
				preventDefault={true}
				draggable
				onDragEnd={(e) => {
					onChange({
						...rectProps,
						x: e.target.x(),
						y: e.target.y(),
					});
				}}
				onTransformEnd={(e) => {
					// transformer is changing scale of the node
					// and NOT its width or height
					// but in the store we have only width and height
					// to match the data better we will reset scale on transform end
					const node = rectRef.current;
					if (!node) return;
					const scaleX = node.scaleX();
					const scaleY = node.scaleY();

					// we will reset it back
					node.scaleX(1);
					node.scaleY(1);
					onChange({
						...rectProps,
						x: node.x(),
						y: node.y(),
						// set minimal value
						width: Math.max(5, node.width() * scaleX),
						height: Math.max(node.height() * scaleY),
					});
				}}
			/>
			{isSelected && (
				<Transformer
					/* @ts-ignore */
					ref={trRef}
					boundBoxFunc={(oldBox, newBox) => {
						// limit resize
						if (newBox.width < 5 || newBox.height < 5) {
							return oldBox;
						}
						return newBox;
					}}
				/>
			)}
		</React.Fragment>
	);
};

/**
 * 画像をステージのサイズに合う拡大縮小の比率を求める。
 * @param stageH
 * @param stageW
 * @param imageH
 * @param imageW
 * @returns
 */
const calcFitImageSizeToStage = (
	stageH: number,
	stageW: number,
	imageH: number,
	imageW: number,
): t_size => {
	const hw = { height: imageH, width: imageW } as const;
	const ratioH = stageH / imageH;
	const ratioW = stageW / imageW;
	//ステージからはみ出ない方の拡大縮小比率を選択する。imageサイズが0だとratioがinifinityになるのでそのときは1を返す。
	const ratio = ((r) => (Number.isFinite(r) ? r : 1))(
		imageH * ratioW > stageH ? ratioH : ratioW,
		//imageW > imageH ? stageW / imageW : stageH / imageH,
		//stageH > stageW ? stageW / imageW : stageH / imageH,
	);
	/*
	console.log({
		ratio: ratio,
		imgheight: imageH,
		imgwidth: imageW,
		stageH: stageH,
		stageW: stageW,
		r1: imageH * (stageW / imageW),
		r2: imageW * (stageH / imageH),
	});*/
	return R.map<t_size, t_size>(R.multiply(ratio), hw);
};

const marginForCenter = (stageSize: t_size, imageSize: t_size): t_position => ({
	x: (stageSize.width - imageSize.width) / 2,
	y: (stageSize.height - imageSize.height) / 2,
});
